import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import Home from "@/pages/Home";
import Admin from "@/pages/AdminPanel";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
    </MotionConfig>
  );
}

export default App;
